import React from "react";
import { Dialog } from "@headlessui/react";
import { useState } from "react";
import Spinner from "../../Spinner";
import GoogleLogin from "react-google-login";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import {
  locationWithPermission,
  locationWithoutPermission,
} from "../../../redux/actions/location";
import { locationCheck } from "../../../utils/locationCheck";
import { setLocation } from "../../../redux/actions/location";
import {
  getXanoAuthToken,
  getXanoAuthFacebookToken,
  getXanoAuthEmailToken,
  sendOtp,
  verifyOtp,
  resendOtp,
  resetPassword,
  logout,
  sendOtpFromEmail,
  requestOtp,
  validatePasswordResetAccess,
  updatePassword,
  requestResendOtp,
  setOnboardingPhase,
} from "../../../redux/actions/authentication";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Mixpanel } from "../../../config/Mixpanel";
import ReactPixel from "react-facebook-pixel";
import Constants from "../../../common/constants";
import { useCookies } from "react-cookie";
import {
  XANO_GOOGLE_CLIENT_ID,
  XANO_FACEBOOK_APP_ID,
} from "../../../config/api_config";
import { PhoneNumberUtil } from "google-libphonenumber";
import { countryPhoneCodes } from "../../../pages/LandingPage/countryPhoneCode";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import CountryCode from "../../../pages/LandingPage/CountryCode";
import { fetchIsUserFromBetaProduct } from "../../../redux/actions/personaliseCourse";
import { setActivationPhase } from "../../../redux/actions/contentPayer";
import { SET_IS_ACTIVATION } from "../../../redux/actions/types";
import LoginLogo from "./LoginLogo";

const LoginModal = ({ isModalEnabled, setIsModalEnabled }) => {
  const [emailFormData, setEmailFormData] = useState({
    email: "",
    password: "",
  });
  const [email, setEmail] = useState("");
  const [isEmailFormEnabled, setIsEmailFormEnabled] = useState(true);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [userJWT, setUserJWT] = useState(null);
  const [mobile, setMobile] = useState("");
  const [OTP, setOTP] = useState("");
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isResendOtp, setIsResendOtp] = useState(false);
  const [passwords, setPasswords] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [selectedCountry, setSelectedCountry] = useState(
    countryPhoneCodes.find((el) => el?.name === "India")
  );
  const [cookies, setCookie, removeCookie] = useCookies();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [phoneNumber, setPhoneNumber] = useState("");
  const userLocation = useSelector((store) => store?.location);

  const [isVerifyOtpLoading, setIsVerifyOtpLoading] = useState(false);
  const [isSendOtpLoading, setIsSendOtpLoading] = useState(false);
  const [isLoginLoading, setIsLoginLoading] = useState(false);
  const [isResetLoading, setIsResetLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const phoneUtil = PhoneNumberUtil.getInstance();
  const regex = /^\d+$/;
  const [authToken, setAuthToken] = useState("");
  const [originalPhoneNumber, setOriginalPhoneNumber] = useState("");
  const [originalEmail, setOriginalEmail] = useState("");

  const getLocation = async (userId) => {
    const result = await locationCheck(userId);
    //console.log(result);
    if (result === true) {
      //console.log('calllleddd')
      dispatch(setLocation(userId));
    } else {
      //console.log('GOOOO' );
      dispatch(locationWithoutPermission(userId));
      const successCallback = async (data) => {
        const latitude = data.coords.latitude;
        const longitude = data.coords.longitude;

        dispatch(locationWithPermission(userId, latitude, longitude));
      };

      setTimeout(() => {
        navigator.geolocation.getCurrentPosition(
          successCallback,
          (error) => { }
        );
      }, 3000);
    }
  };

  async function authResponse(response) {
    setIsModalEnabled(false);
    setIsLoading(true);

    if (response.error || (response.status && response.status === "unknown")) {
      console.log("Auth Failed: ", response.error);
    } else {
      const tokenID = response?.tokenObj?.access_token;

      await dispatch(
        getXanoAuthToken(tokenID, (successObj) => {
          const userId = successObj?.user_coins_data?.[0]?.user_id;

          getLocation(userId);

          Mixpanel.identify(successObj?.email);
          Mixpanel.track(Constants.Mixpanel.LOG_IN, {
            distinct_id: successObj?.email,
          });
          Mixpanel.people.set({
            $first_name: successObj?.first_name,
            $last_name: successObj?.last_name,
          });
          if (successObj.number_verification) {
            navigate(
              location?.state?.from?.pathname
                ? location?.state?.from?.pathname
                : "/courses",
              { replace: true }
            );
          } else {
            // ReactPixel.trackSingle("333999584825866", "Lead");
            if (successObj?.show_toast) {
              toast.error(successObj?.message);
            } else {
              navigate("/verification", { replace: true });
            }
          }
        })
      );

      
      dispatch(
        fetchIsUserFromBetaProduct(
          (res) => {
            console.log("monday", res);
            if (
              res?.data?.is_ninjacurate_user ||
              res?.data?.ninjacurate_is_paid
            ) {
              dispatch(
                setOnboardingPhase(
                  (res1) => { },
                  (err1) => { }
                )
              );
              dispatch(
                setActivationPhase((successObj) =>
                  dispatch({ type: SET_IS_ACTIVATION, payload: false })
                )
              );
            }
          },
          (err) => { }
        )
      );
    }
    setIsLoading(false);
  }

  async function authFacebookResponse(response) {
    setIsModalEnabled(false);
    if (response.error || (response.status && response.status === "unknown")) {
      console.log("Auth Failed: ", response.error);
    } else {
      console.log(response);
      const tokenID = response?.accessToken;

      // console.log("Auth Success: ", tokenID);
      await dispatch(
        getXanoAuthFacebookToken(tokenID, (successObj) => {
          setIsModalEnabled(false);
          const userId = successObj?.user_coins_data?.[0]?.user_id;

          getLocation(userId);

          console.log(successObj);

          Mixpanel.identify(successObj?.email);
          Mixpanel.track(Constants.Mixpanel.LOG_IN, {
            distinct_id: successObj?.email,
          });
          Mixpanel.people.set({
            $first_name: successObj?.first_name,
            $last_name: successObj?.last_name,
          });
          if (successObj.number_verification) {
            navigate(
              location?.state?.from?.pathname
                ? location?.state?.from?.pathname
                : "/courses",
              { replace: true }
            );
          } else {
            // ReactPixel.trackSingle("333999584825866", "Lead");
            if (successObj?.show_toast) {
              toast.error(successObj?.message);
            } else {
              navigate("/verification", { replace: true });
            }
          }
        })
      );
      dispatch(
        fetchIsUserFromBetaProduct(
          (res) => {
            console.log("monday", res);
            if (
              res?.data?.is_ninjacurate_user ||
              res?.data?.ninjacurate_is_paid
            ) {
              dispatch(
                setOnboardingPhase(
                  (res1) => { },
                  (err1) => { }
                )
              );
              dispatch(
                setActivationPhase((successObj) =>
                  dispatch({ type: SET_IS_ACTIVATION, payload: false })
                )
              );
            }
          },
          (err) => { }
        )
      );
    }
  }

  const onSubmit = () => {
    // console.log(email);
    setIsSendOtpLoading(true);
    setOriginalEmail(email);
    setOriginalPhoneNumber(selectedCountry?.dial_code + phoneNumber);
    if (email?.length > 0) {
      dispatch(
        requestOtp(
          email,
          "",
          "email",
          (successObj) => {
            if (successObj?.result === "success") {
              //console.log(response.data.jwt);
              setIsOtpSent(true);
              toast.success(successObj?.message, {
                closeButton: false,
              });
              setUserJWT(successObj?.data?.jwt);
              setPhoneNumber(successObj?.data?.phone_number);
              //successCallback(response);
            } else {
              toast.error(successObj?.message);
              setIsSendOtpLoading(false);
            }
          },
          (errorObj) => {
            toast.error("Enter Valid Email");
            setIsSendOtpLoading(false);
          }
        )
      );
    } else {
      if (
        (selectedCountry?.dial_code + phoneNumber)[0] === "+" &&
        regex.test((selectedCountry?.dial_code + phoneNumber).slice(1))
      ) {
        if (
          !phoneUtil.isValidNumberForRegion(
            phoneUtil.parse(phoneNumber, selectedCountry?.code),
            selectedCountry?.code
          )
        ) {
          toast.error("Enter Valid Phone Number");
          return;
        } else {
          dispatch(
            requestOtp(
              "",
              selectedCountry?.dial_code + phoneNumber,
              "phone_number",
              (successObj) => {
                if (successObj?.result === "success") {
                  //console.log(response.data.jwt);
                  setIsOtpSent(true);
                  toast.success(successObj?.message, {
                    closeButton: false,
                  });
                  setUserJWT(successObj?.data?.jwt);
                  setPhoneNumber(successObj?.data?.phone_number);
                  //successCallback(response);
                } else {
                  toast.error(successObj?.message);
                  setIsSendOtpLoading(false);
                }
              },
              (errorObj) => {
                toast.error("Enter Valid Email");
                setIsSendOtpLoading(false);
              }
            )
          );
        }
      } else {
        toast.error("Enter Valid Phone Number");
        return;
      }
    }
  };

  const verifyOTP = () => {
    setIsVerifyOtpLoading(true);
    dispatch(
      validatePasswordResetAccess(userJWT, OTP, (successObj) => {
        //console.log(successObj);
        if (successObj?.result === "success") {
          console.log("it ran");
          setIsOtpVerified(true);
          setAuthToken(successObj?.data?.authToken);
          setEmail(successObj?.data?.email);
          ReactPixel.trackSingle("333999584825866", "Lead");
        } else {
          toast.error(successObj?.message, {
            closeButton: false,
          });
          setIsVerifyOtpLoading(false);
        }
      })
    );
  };

  const resendOTP = (type) => {
    if (originalEmail?.length > 0) {
      dispatch(
        requestResendOtp(
          originalEmail,
          "",
          "email",
          type,
          (successObj) => {
            //console.log(success);
            if (successObj?.result === "success") {
              //console.log(response.data.jwt);
              setIsOtpSent(true);
              toast.success(successObj?.message, {
                closeButton: false,
              });
              setPhoneNumber(successObj?.data?.phone_number);
              //successCallback(response);
            } else {
              toast.error(successObj?.message);
              setIsSendOtpLoading(false);
            }
          },
          (errorObj) => {
            toast.error("Enter Valid Email");
            setIsSendOtpLoading(false);
          }
        )
      );
    } else {
      dispatch(
        requestResendOtp(
          "",
          originalPhoneNumber,
          "phone_number",
          type,
          (successObj) => {
            //console.log(success);
            if (successObj?.result === "success") {
              //console.log(response.data.jwt);
              setIsOtpSent(true);
              toast.success(successObj?.message, {
                closeButton: false,
              });
              setPhoneNumber(successObj?.data?.phone_number);
              //successCallback(response);
            } else {
              toast.error(successObj?.message);
              setIsSendOtpLoading(false);
            }
          },
          (errorObj) => {
            toast.error("Enter Valid Phone Number");
            setIsSendOtpLoading(false);
          }
        )
      );
    }
  };

  const onChange = (event) => {
    setEmailFormData({
      ...emailFormData,
      [event.target.name]: event.target.value,
    });
  };

  const emailSignIn = async () => {
    setIsLoginLoading(true);

    await dispatch(
      getXanoAuthEmailToken(
        emailFormData.email,
        emailFormData.password,
        (successObj) => {
          //console.log(successObj);
          setIsModalEnabled(false);
          const userId = successObj?.user_coins_data?.[0]?.user_id;
          Mixpanel.identify(successObj?.email);
          Mixpanel.track(Constants.Mixpanel.LOG_IN, {
            distinct_id: successObj?.email,
          });
          Mixpanel.people.set({
            $first_name: successObj?.first_name,
            $last_name: successObj?.last_name,
          });
          if (successObj.number_verification) {
            navigate(
              location?.state?.from?.pathname
                ? location?.state?.from?.pathname
                : "/courses",
              { replace: true }
            );
          } else {
            // ReactPixel.trackSingle("333999584825866", "Lead");
            if (successObj?.show_toast) {
              toast.error(successObj?.message);
            } else {
              navigate("/verification", { replace: true });
            }
          }
        },
        (errorObj) => {
          toast.error("Enter Valid Credentials");
          setIsLoginLoading(false);
        }
      )
    );

    dispatch(
      fetchIsUserFromBetaProduct(
        (res) => {
          console.log("monday", res);
          if (
            res?.data?.is_ninjacurate_user ||
            res?.data?.ninjacurate_is_paid
          ) {
            dispatch(
              setOnboardingPhase(
                (res1) => { },
                (err1) => { }
              )
            );
            dispatch(
              setActivationPhase((successObj) =>
                dispatch({ type: SET_IS_ACTIVATION, payload: false })
              )
            );
          }
        },
        (err) => { }
      )
    );
  };
  function logoutHandler() {
    dispatch(logout());
    removeCookie("authToken", { path: "/" });
    navigate("/courses");
  }

  const onResetPassword = () => {
    setIsResetLoading(true);
    if (passwords.newPassword !== passwords.confirmPassword) {
      toast.error("Passwords do not Match");
      setIsResetLoading(false);
    } else if (passwords.newPassword.length < 8) {
      toast.error("Minimum 8 characters Required!!");
      setIsResetLoading(false);
    } else {
      dispatch(
        updatePassword(authToken, passwords.newPassword, (successObj) => {
          //console.log(successObj);
          setIsModalEnabled(false);
          toast.success(`Password Changed, Login Again`, {
            closeButton: false,
          });

          logoutHandler();
        })
      );
    }
  };

  {
    if (isEmailFormEnabled === true) {
      return (
        <div>
          <Dialog
            open={isModalEnabled}
            onClose={() => setIsModalEnabled(!isModalEnabled)}
            as="div"
            className="fixed inset-0 z-10 flex flex-col  items-center justify-center overflow-y-auto"
          >
            <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
            <Dialog.Title />
            <Dialog.Description />
            <div className="z-10 flex w-11/12 flex-col items-center justify-center rounded-xl bg-[#2D4F71] py-6 px-4 shadow-2xl md:w-3/5  lg:w-[25%]">
              <div className="mx-auto flex items-center rounded bg-white py-1 px-2 ">
                <LoginLogo />
              </div>
              <div className="mt-4 flex w-full flex-col items-center justify-center">
                <div className="mb-2 w-full self-start">
                  <h1 className="  mb-5 text-[20px] font-semibold text-white">
                    Login To Your Account
                  </h1>
                  <GoogleLogin
                    clientId={XANO_GOOGLE_CLIENT_ID}
                    render={(renderProps) => {
                      return (
                        <button
                          onClick={renderProps.onClick}
                          disabled={renderProps.disabled}
                          className="w-full rounded-md bg-[#3B82F6] px-4 py-2 text-[16px] font-semibold text-white  md:text-lg"
                        >
                          {!renderProps.disabled && (
                            <div className="flex flex-row gap-2">
                              <img
                                src="/stocksvgs/googleicon.svg"
                                className="p-1/2 h-6 w-6 self-start rounded-full bg-white"
                                alt="google icon"
                              />
                              <span className="text-md mx-auto md:text-sm">
                                Sign In with Google
                              </span>
                            </div>
                          )}
                        </button>
                      );
                    }}
                    onSuccess={authResponse}
                    onFailure={authResponse}
                    // uxMode="redirect"
                    // redirectUri={window.location.origin + "/login"}
                    cookiePolicy={"single_host_origin"}
                  />
                  {/* <FacebookLogin
                    appId={XANO_FACEBOOK_APP_ID}
                    fields="name,email,picture"
                    autoLoad={false}
                    disableMobileRedirect={true}
                    callback={authFacebookResponse}
                    render={(renderProps) => {
                      return (
                        <button
                          onClick={renderProps.onClick}
                          disabled={renderProps.isDisabled}
                          className="mt-2 w-full rounded-md bg-[#1D4ED8] px-4 py-2 text-[16px] font-semibold  text-white md:text-lg"
                        >
                          {!renderProps.isDisabled ? (
                            <div className="flex flex-row gap-2">
                              <object
                                type="image/svg+xml"
                                data="/stocksvgs/facebookicon.svg"
                                className="p-1/2 h-6 w-6 self-start bg-[#1D4ED8]"
                              ></object>
                              <span className="text-md mx-auto md:text-sm">
                                Sign In with Facebook
                              </span>
                            </div>
                          ) : (
                            <Spinner
                              className={
                                "flex h-4 w-4 scale-50 items-center justify-center"
                              }
                            ></Spinner>
                          )}
                        </button>
                      );
                    }}
                  /> */}
                  <div className="mb-3 mt-3 flex justify-center text-[12px] font-semibold text-white">
                    or use Email address
                  </div>
                  <label
                    htmlFor="email-address"
                    className="text-[16px] font-medium text-white"
                  >
                    Email
                  </label>
                  <input
                    id="email-address"
                    name="email"
                    type="email"
                    required
                    onChange={onChange}
                    className="w-full appearance-none  rounded-md border border-[#223548] bg-[#223548] text-white placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  />
                </div>
                <div className="mb-2 w-full self-start">
                  <label
                    htmlFor="password"
                    className="text-[16px] font-medium text-white"
                  >
                    Password
                  </label>
                  <input
                    id="password"
                    name="password"
                    type="password"
                    required
                    onChange={onChange}
                    className="w-full appearance-none  rounded-md border border-[#223548] bg-[#223548] text-white placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  />
                </div>
                <a
                  className="mb-2 cursor-pointer self-start text-[14px] font-semibold text-white underline "
                  onClick={(e) => setIsEmailFormEnabled(false)}
                >
                  Forgot Email/Password?
                </a>
                <button
                  disabled={isLoginLoading}
                  className=" mt-4 h-10 w-full rounded-lg bg-[#25BD4C] text-[16px] font-bold text-white"
                  onClick={(event) => emailSignIn()}
                >
                  {isLoginLoading ? "Logging In..." : "Login"}
                </button>
              </div>
            </div>
          </Dialog>
        </div>
      );
    } else if (isOtpVerified === true) {
      return (
        <div>
          <Dialog
            open={isModalEnabled}
            onClose={() => setIsModalEnabled(!isModalEnabled)}
            as="div"
            className="fixed inset-0 z-10 flex flex-col  items-center justify-center overflow-y-auto"
          >
            <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
            <Dialog.Title />
            <Dialog.Description />
            <div className="z-10 flex w-11/12 flex-col items-center justify-center rounded-xl bg-[#2D4F71] py-6 px-4 shadow-2xl md:w-3/5  lg:w-[25%]">
              <div className="mx-auto flex items-center rounded bg-white py-1 px-2 ">
                <LoginLogo />
              </div>
              <div className="flex w-full flex-col items-center justify-center">
                <div className="mt-4 flex w-full flex-col self-start leading-tight">
                  <h1 className="text-[20px] font-semibold text-white">
                    Reset Password
                  </h1>
                  <div className="text-[14px] font-medium text-gray-300">
                    Email: {email}
                  </div>
                  <div className="mt-4 flex flex-col">
                    <label
                      htmlFor="password"
                      className="text-[16px] font-medium text-white"
                    >
                      New Password
                    </label>
                    <div className="mt-1 flex h-[44px] w-full ">
                      <input
                        id="newpassword"
                        name="password"
                        type={isVisible ? "text" : "password"}
                        onChange={(event) =>
                          setPasswords({
                            ...passwords,
                            newPassword: event.target.value,
                          })
                        }
                        required
                        className="w-full appearance-none rounded-l-lg border border-[#223548] bg-[#223548] text-white placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                      />
                      <FontAwesomeIcon
                        icon={isVisible ? faEyeSlash : faEye}
                        className="cursor-pointer rounded-tr-lg rounded-br-lg bg-[#223548] p-3.5 text-[#7FC241]"
                        onClick={(e) => setIsVisible(!isVisible)}
                      />
                    </div>
                  </div>
                  <div className="mt-4 flex flex-col ">
                    <label
                      htmlFor="password"
                      className="text-[16px] font-medium text-white"
                    >
                      Confirm New Password
                    </label>
                    <input
                      id="confirmpassword"
                      name="password"
                      type="password"
                      onChange={(event) =>
                        setPasswords({
                          ...passwords,
                          confirmPassword: event.target.value,
                        })
                      }
                      required
                      className="w-full appearance-none  rounded-md border border-[#223548] bg-[#223548] text-white placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>
                <button
                  disabled={isResetLoading}
                  className="mt-4 h-10 w-full rounded-lg bg-[#25BD4C] text-[16px] font-bold text-white"
                  onClick={(event) => onResetPassword()}
                >
                  {isResetLoading ? "Updating Password..." : "Reset Password"}
                </button>
              </div>
            </div>
          </Dialog>
        </div>
      );
    } else if (isOtpSent === true) {
      return (
        <div>
          <Dialog
            open={isModalEnabled}
            onClose={() => setIsModalEnabled(!isModalEnabled)}
            as="div"
            className="fixed inset-0 z-10 flex flex-col  items-center justify-center overflow-y-auto"
          >
            <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
            <Dialog.Title />
            <Dialog.Description />
            <div className="z-10 flex w-11/12 flex-col items-center justify-center rounded-xl bg-[#2D4F71] py-6 px-4 shadow-2xl md:w-3/5  lg:w-[25%]">
              <div className="mx-auto flex items-center rounded bg-white py-1 px-2 ">
                <LoginLogo />
              </div>
              <div className="flex w-full flex-col items-center justify-center">
                <div className="mt-4 w-full self-start">
                  <h1 className="text-[20px] font-semibold text-white ">
                    Verify OTP
                  </h1>
                  <h4 className="text-[14px] text-stone-300">
                    OTP sent to your Registered phone number.
                  </h4>
                  <h4
                    className="mb-7 cursor-pointer self-start text-xs font-medium text-[#18A5D6] underline "
                    onClick={(e) => {
                      setEmail("");
                      setPhoneNumber("");
                      setOriginalEmail("");
                      setOriginalPhoneNumber("");
                      setIsOtpSent(false);
                      setUserJWT(null);
                      setIsSendOtpLoading(false);
                      setMobile("");
                    }}
                  >
                    Change {phoneNumber}?
                  </h4>
                  <h1 className="text-[16px] font-medium text-white">
                    Enter OTP
                  </h1>
                  <input
                    id="otp"
                    name="otp"
                    type="text"
                    onChange={(event) => setOTP(event.target.value)}
                    required
                    className="w-full appearance-none rounded-md border border-[#223548] bg-[#223548] px-3 py-2 text-white placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  />
                </div>
                <a
                  className="mt-2 cursor-pointer self-start text-xs text-[14px] font-semibold text-white underline"
                  onClick={(e) => {
                    setIsResendOtp(!isResendOtp);
                  }}
                >
                  Resend OTP
                </a>
                {isResendOtp && (
                  <div className="mb-2 mt-2 flex w-full items-center justify-between gap-2">
                    <button
                      className="w-full cursor-pointer rounded bg-cn_green p-2 text-sm text-white hover:bg-green-400 disabled:bg-slate-400"
                      onClick={() => resendOTP("voice")}
                    >
                      OTP On Call
                    </button>
                    <button
                      className="w-full cursor-pointer rounded bg-cn_green p-2 text-sm text-white hover:bg-green-400 disabled:bg-slate-400"
                      onClick={() => resendOTP("text")}
                    >
                      OTP on SMS
                    </button>
                  </div>
                )}

                <button
                  disabled={isVerifyOtpLoading}
                  className=" mt-4 h-10 w-full  rounded-lg bg-[#25BD4C] font-bold text-white"
                  onClick={(event) => verifyOTP()}
                >
                  {isVerifyOtpLoading ? "Verifying..." : "Verify"}
                </button>
              </div>
            </div>
          </Dialog>
        </div>
      );
    } else {
      return (
        <div>
          <Dialog
            open={isModalEnabled}
            onClose={() => setIsModalEnabled(!isModalEnabled)}
            as="div"
            className="fixed inset-0 z-10 flex flex-col  items-center justify-center overflow-y-auto"
          >
            <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
            <Dialog.Title />
            <Dialog.Description />
            <div className="z-10 flex w-11/12 flex-col items-center justify-center rounded-xl bg-[#2D4F71] py-6 px-4 shadow-2xl md:w-3/5  lg:w-[25%]">
              <div className="mx-auto flex items-center rounded bg-white py-1 px-2 ">
                <LoginLogo />
              </div>
              <div className="mt-4 flex w-full flex-col items-center justify-center ">
                <div className="mb-2 flex w-full flex-col self-start">
                  <h1 className="  text-[20px] font-semibold text-white">
                    Forgot Email/Password
                  </h1>
                  {/* <small className="mb-7 text-xs text-stone-500 ">
                    Enter your email address to send OTP to your registered number
                    to reset password
                  </small> */}

                  <div className="mt-4">
                    <label
                      htmlFor="email-address"
                      className="text-[16px] font-medium text-white"
                    >
                      Email
                    </label>
                    <input
                      id="email-address"
                      name="email"
                      type="email"
                      disabled={phoneNumber?.length > 0}
                      onChange={(event) => setEmail(event.target.value)}
                      required
                      className="w-full appearance-none rounded-md border border-[#223548] bg-[#223548] text-white placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 disabled:bg-gray-400 sm:text-sm"
                    />
                    <div className="my-4 text-center text-[12px] font-semibold text-white">
                      Or
                    </div>
                    <label
                      htmlFor="email-address"
                      className="text-[16px] font-medium text-white"
                    >
                      Phone Number
                    </label>
                    <div className="flex gap-2">
                      <div className="w-[35%]">
                        <CountryCode
                          selected={selectedCountry}
                          setSelected={setSelectedCountry}
                          disable={email?.length > 0}
                        />
                      </div>
                      <div className="mt-1 flex-1">
                        <input
                          id="phone-number"
                          name="phone"
                          type="tel"
                          disabled={email?.length > 0}
                          onChange={(event) =>
                            setPhoneNumber(event.target.value)
                          }
                          placeholder="Phone Number"
                          pattern="[0-9.]+"
                          required
                          className={`w-full appearance-none rounded-md border bg-[#223548] px-3 py-2  
                                  ${"text-white/50"} placeholder:text-sm placeholder:font-semibold placeholder:text-white/50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 disabled:bg-gray-400 sm:text-sm`}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  disabled={isSendOtpLoading}
                  className="mt-4 h-10 w-full rounded-lg bg-[#25BD4C] text-white"
                  onClick={(event) => onSubmit()}
                >
                  {isSendOtpLoading ? "Sending..." : "Send OTP"}
                </button>
              </div>
            </div>
          </Dialog>
        </div>
      );
    }
  }
};

export default LoginModal;
